import { Box, useMediaQuery, useTheme } from '@mui/material';
import { getYear } from 'date-fns';
import { FormattedMessage } from 'react-intl';

import {
  isAureaActiveClient,
  isBfacmActiveClient,
  isBpcActiveClient,
  isBvalorActiveClient,
  isFinantechActiveClient,
  isHemeraActiveClient,
  isStinvestActiveClient,
} from '»utils/clientsUtils';

import { CopyrightStyled } from './Copyright.styles';

export const Copyright = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  const currentYear = getYear(new Date());

  const getCopyrightExpression = () => {
    if (isAureaActiveClient) return 'TRLT_UI-2022_AUREA';

    if (isStinvestActiveClient) return 'TRLT_UI-2022_STANDARD';

    if (isHemeraActiveClient) return 'TRLT_UI-2022_HEMERA';

    if (isBfacmActiveClient) return 'TRLT_UI-2022_BFACM';

    if (isBpcActiveClient) return 'TRLT_UI-2024_BPC';

    if (isBvalorActiveClient) return 'TRLT_UI-2026_BVALOR';

    return 'TRLT_UI-2022_FINANTECH';
  };

  return (
    <CopyrightStyled>
      <Box>
        <FormattedMessage
          id={getCopyrightExpression()}
          values={{ currentYear }}
        />
      </Box>
      {isBfacmActiveClient && (
        <Box id="legalWarning">
          <FormattedMessage id="TRLT_UI-LEGAL_BFACM" />
        </Box>
      )}
      {matches && isFinantechActiveClient && (
        <>
          <Box>
            <FormattedMessage id="TRLT_UI-TERMS_CONDITIONS" />
          </Box>
          <Box>
            <FormattedMessage id="TRLT_UI-PRIVACY_POLICY" />
          </Box>
          <Box>
            <FormattedMessage id="TRLT_UI-FAQ" />
          </Box>
        </>
      )}
    </CopyrightStyled>
  );
};
